module.exports = __webpack_public_path__ + "static/media/dropbox.4fa78cea.svg";